/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Count_OneInputs */



/**
* | output |
* | --- |
* | "1 file(s)" |
*
* @param {File_Count_OneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_count_one = /** @type {((inputs?: File_Count_OneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Count_OneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("1 fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("1 Datei(en)")
	if (locale === "it") return /** @type {LocalizedString} */ ("1 file(i)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("1 файл(а)")
	if (locale === "es") return /** @type {LocalizedString} */ ("1 archivo(s)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("1 个文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1 ファイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("1 फ़ाइल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("1 arquivo(s)")
	return /** @type {LocalizedString} */ ("1 file(s)")
});